import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import type { Props } from './types';
import messages from '../messages';

function parseAdverseFactors(adverseFactors) {
  if (!adverseFactors) return [];
  if (Array.isArray(adverseFactors)) return adverseFactors;
  try {
    const parsed = JSON.parse(adverseFactors);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function RecommendedScreeningResult({
  intl,
  applicationRecommendation,
  detailRecommendation,
  adverseFactors,
}: Props) {
  const factors = parseAdverseFactors(adverseFactors);

  return (
    <Stack spacing={1} padding={2} paddingRight={6}>
      <Typography variant="titleSmall" fontWeight="bold">
        {intl.formatMessage(messages.recommendedScreeningResult)}
      </Typography>
      {detailRecommendation && detailRecommendation.length > 0 && (
        <Typography variant="bodySmall" color="text.secondary">
          {detailRecommendation}
        </Typography>
      )}
      <Stack spacing={1}>
        <Typography variant="titleSmall" fontWeight="bold">
          {intl.formatMessage(messages.recommendedOverallApplicationResult)}
        </Typography>
        <Typography variant="bodySmall" color="text.secondary">
          {applicationRecommendation && applicationRecommendation.length > 0
            ? applicationRecommendation
            : intl.formatMessage(messages.noAdditionalDetailsFound)}
        </Typography>
      </Stack>
      <Stack spacing={1}>
        <Typography variant="titleSmall" fontWeight="bold">
          {intl.formatMessage(messages.whyThisRecommendation)}
        </Typography>
        {factors.length > 0 ? (
          <Stack component="ul" spacing={0.5} margin={0} paddingLeft={2}>
            {factors.map((factor, index) => (
              <Typography
                component="li"
                variant="bodySmall"
                color="text.secondary"
                key={`${factor}-${index}`}
              >
                {factor}
              </Typography>
            ))}
          </Stack>
        ) : (
          <Typography variant="bodySmall">
            {intl.formatMessage(messages.noAdditionalDetailsFound)}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

export default RecommendedScreeningResult;
